export default __webpack_public_path__ + "static/media/dashboard.9e272aff.png";